import { ofType } from 'redux-observable';
import {
	switchMap,
	map,
	catchError,
} from 'rxjs/operators';
import { rxjsFileUploadFetcher } from '../../../lib/general-utils';
import {
	actionTypes,
	conversationReplyActions,
	conversationErrorActions,
	notifyActions,
} from '../../../controller';
import { ErrorEventEnum } from '../../../lib/enums';
import {
	catchErrorForEpics,
} from '../../../../lib/epic-utils';
import { buildUrl } from '../../../../lib/api-fetcher/utils';

const {
	START_CREATE_FILE_CONVERSATION_REPLY,
	START_CREATE_FORM_FILE_CONVERSATION_REPLY,
	START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY,
	START_CREATE_QUICK_FORM_CONVERSATION_REPLY,
} = actionTypes;
const {
	notifyErrorAction,
} = notifyActions;
const {
	createFileConversationReplySuccessAction,
	createFileConversationReplyFailedAction,
	createFormFileConversationReplySuccessAction,
	createFormFileConversationReplyFailedAction,
	createQAFormFileConversationReplySuccessAction,
	createQAFormFileConversationReplyFailedAction,
	createQuickFormConversationReplySuccessAction,
	createQuickFormConversationReplyFailedAction,
} = conversationReplyActions;
const {
	getConversationSilenceAction,
} = conversationErrorActions;
const { SILENCE_EVENT } = ErrorEventEnum;

export function createFileConversationReplyEpic(action$) {
	return action$.pipe(
		ofType(START_CREATE_FILE_CONVERSATION_REPLY),
		switchMap(({ conversationType, file, quoteReplyId } = {}) => {
			const formFile = new FormData();

			formFile.append('file', file);

			return rxjsFileUploadFetcher
				.post('conversation/replies', formFile, {
					queries: {
						type: conversationType,
						quoteReplyId,
					},
				})
				.pipe(
					map(() => createFileConversationReplySuccessAction()),
					catchError(error => {
						const { response } = error;

						if (response.code === SILENCE_EVENT) {
							const { blockTo, customRateLimitErrorMessage = '' } = response.option;

							return [
								getConversationSilenceAction(blockTo, customRateLimitErrorMessage),
								...catchErrorForEpics(error, createFileConversationReplyFailedAction),
							];
						}

						return catchErrorForEpics(error, createFileConversationReplyFailedAction, notifyErrorAction);
					}),
				);
		}));
}

export function createFormFileConversationReplyEpic(action$) {
	return action$.pipe(
		ofType(START_CREATE_FORM_FILE_CONVERSATION_REPLY),
		switchMap(({ data } = {}) => {
			const { file, captchaKey, captchaSecret } = data;
			const createReplyUploadImageUrl = buildUrl('conversation/replies?type=upload-image', {
				captchaKey,
				captchaSecret,
			});
			const formFile = new FormData();

			formFile.append('file', file);

			return rxjsFileUploadFetcher
				.post(createReplyUploadImageUrl, formFile)
				.pipe(
					map(() => createFormFileConversationReplySuccessAction()),
					catchError(error => catchErrorForEpics(error, createFormFileConversationReplyFailedAction, notifyErrorAction)),
				);
		}));
}

export function createQAFormFileConversationReplyEpic(action$) {
	return action$.pipe(
		ofType(START_CREATE_QA_FORM_FILE_CONVERSATION_REPLY),
		switchMap(({ conversationReplyId, file, options } = {}) => {
			const { title, type: fileType } = options;
			const formFile = new FormData();

			formFile.append('file', file);

			return rxjsFileUploadFetcher
				.post(`conversation/replies/id=${conversationReplyId}/file`, formFile, { queries: { type: fileType } })
				.pipe(
					map(payload => createQAFormFileConversationReplySuccessAction(payload.response, { conversationReplyId, title })),
					catchError(error => catchErrorForEpics(error, createQAFormFileConversationReplyFailedAction, notifyErrorAction)),
				);
		}));
}

// POST  /api/v1/conversation/replies?type=quick-action-form-reply
// https://app.gitbook.com/o/-LSmguN2bxAKDgeXkorc/s/-MF-7vQ7EQDyWfUwVpw4/cs-spec.-v2.0/client-ke-hu-duan/888.014-conversation-1/conversation-reply
export function createQuickFormConversationReplyEpic(action$) {
	return action$.pipe(
		ofType(START_CREATE_QUICK_FORM_CONVERSATION_REPLY),
		switchMap(({ formData } = {}) => rxjsFileUploadFetcher
			.post('conversation/replies?type=quick-action-form-reply', formData)
			.pipe(
				map(() => createQuickFormConversationReplySuccessAction()),
				catchError(error => catchErrorForEpics(error, createQuickFormConversationReplyFailedAction, notifyErrorAction)),
			),
		),
	);
}
